const AnalyteIndex = () => import("@/pages/lab/analyte/AnalyteIndex");
const AnalyteDetail = () => import("@/pages/lab/analyte/AnalyteDetail");
const AnalyteAdd = () => import("@/pages/lab/analyte/AnalyteAdd");
const AnalyteEdit = () => import("@/pages/lab/analyte/AnalyteEdit");
const AnalyteSingle = () => import("@/pages/lab/analyte/AnalyteSingle");
const AnalyteAuditTrail = () => import("@/pages/lab/analyte/AnalyteAuditTrail");
const AnalyteAuditTrailHistory = () => import("@/pages/lab/analyte/AnalyteAuditTrailHistory");
const AnalyteRange = () => import("@/pages/lab/analyte/AnalyteRange");

export class AnalyteRoutes {
  constructor() {
    this.route_root = "analytes";
    this.type_single = "Analyte";
    this.type_plural = "Analytes";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c('router-view')
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: AnalyteIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: AnalyteAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":analyte_id",
            component: AnalyteSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: AnalyteDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: AnalyteEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: AnalyteAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: AnalyteAuditTrailHistory,
                meta: { requiresAuth: true }
              },
              {
                path: "range",
                name: `${this.type_single} Range`,
                component: AnalyteRange,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
